import React from 'react';
import PropTypes from 'prop-types';

const FlowEditPageTitle = ({ title, children = null }) => (
  <div className="d-flex align-items-center page-title px-3">
    <div className="flex-grow-1" />
    <div>{title}</div>
    <div className="flex-grow-1 d-flex justify-content-end">{children}</div>
  </div>
);

FlowEditPageTitle.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node
};

export default FlowEditPageTitle;
